import { render, staticRenderFns } from "./DiscountParametersWidgetWithoutStore.vue?vue&type=template&id=661b3d54&"
import script from "./DiscountParametersWidgetWithoutStore.vue?vue&type=script&lang=js&"
export * from "./DiscountParametersWidgetWithoutStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports